import React, { useState } from "react";
import { Box, Button, Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import Modal, { ModalCloseHandler } from "fond/widgets/Modal";

export interface ColocationLayerDialogProps {
  open: boolean;
  onClose: ModalCloseHandler;
  availableLayers: Array<{ id: string; name: string; icon?: React.ReactNode }>;
  currentEditingLayerId: string;
  initialSelectedLayerIds: string[];
  onSave: (selectedLayerIds: string[]) => void;
}

const ColocationLayerDialog: React.FC<ColocationLayerDialogProps> = ({
  open,
  onClose,
  availableLayers,
  currentEditingLayerId,
  initialSelectedLayerIds,
  onSave,
}) => {
  const [selectedLayerIds, setSelectedLayerIds] = useState<string[]>(initialSelectedLayerIds);

  const handleToggleLayer = (layerId: string) => {
    setSelectedLayerIds((prev) => {
      if (prev.includes(layerId)) {
        return prev.filter((id) => id !== layerId);
      } else {
        return [...prev, layerId];
      }
    });
  };

  const handleSave = (event: React.MouseEvent<HTMLButtonElement>) => {
    onSave(selectedLayerIds);
    onClose(event, "complete");
  };

  const handleCancel = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSelectedLayerIds(initialSelectedLayerIds);
    onClose(event, "cancel");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      header="Select Layers for Colocation Movement"
      headerSubtitle="Choose which layers should move together"
      content={
        <FormGroup>
          {availableLayers.map((layer) => {
            const isCurrentLayer = layer.id === currentEditingLayerId;
            const isSelected = selectedLayerIds.includes(layer.id);

            return (
              <FormControlLabel
                key={layer.id}
                control={<Checkbox checked={isSelected} onChange={() => handleToggleLayer(layer.id)} />}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {layer.icon}
                    <span>{`${layer.name}${isCurrentLayer ? " (current)" : ""}`}</span>
                  </Box>
                }
              />
            );
          })}
        </FormGroup>
      }
      actions={
        <>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </>
      }
      variant="secondary"
    />
  );
};

export default ColocationLayerDialog;
